export async function uploadApi(file) {
  const params = new FormData();
  params.append('file', file);
  return usePost('/upload/cos_file', params, {
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  });
}